module.exports = __webpack_public_path__ + "img/boxes.ddee50e2.png";